import React, { useState } from 'react'


export default function TextForm(props) {
    const [text, setText] = useState(" ");

    const handleUpClick = () => {
        let newText = text.toUpperCase();
        setText(newText);
        props.showAlert("Converted to uppercase","success");
    }
    const handleLowerClick = () => {
        let newText = text.toLowerCase();
        setText(newText);
        props.showAlert("Converted to lowercase","success");
    }
    const handleClearClick = () => {
        let newText = ""
        setText(newText);
        props.showAlert("Text is cleared","success");
    }
    const handleCopyClick = () => {
        var copy=document.getElementById("myBox");
        copy.select();
        navigator.clipboard.writeText(copy.value);
        props.showAlert("Text is copied","success");
    }
    const handleExtraSpaceRemoveClick=()=>{
        let newText=text.split(/[  ]+/);
        setText(newText.join(" "));
        props.showAlert("Extra space is removed","success");
    }
    const handleOnChange = (event) => {
        setText(event.target.value);
    }
    return (
        <>
            <div className='container text-center' style={{color:props.mode==='light'?'black':'white'}} >
                <h3 className='text-center'>{props.heading}</h3>
                <div className="form-floating">
                    <textarea className="form-control p-5" style={{backgroundColor:props.mode==='light'?'white':'black',color:props.mode==='light'?'black':'white'}} value={text} onChange={handleOnChange} placeholder="Leave a comment here" id="myBox"  ></textarea>
                   

                </div>
                <button type="button" disabled={text.length===0} className="btn btn-danger btn-lg m-3" onClick={handleUpClick}>Convert To Uppercase</button>
                <button type="button" disabled={text.length===0} className="btn btn-danger btn-lg" onClick={handleLowerClick}>Convert To Lowercase</button>
                <button type="button" disabled={text.length===0} className="btn btn-danger btn-lg m-3" onClick={handleExtraSpaceRemoveClick}>Extra Space Remover</button>
                <button type="button" disabled={text.length===0} className="btn btn-danger btn-lg m-3" onClick={handleClearClick}>Clear Text</button>
                <button type="button" disabled={text.length===0} className="btn btn-danger btn-lg m-3" onClick={handleCopyClick}>Copy Text</button>
            </div>
            <div className="container my-3" style={{color:props.mode==='light'?'black':'white'}} >
                <h1>Your Text Summary</h1>
                <p><b>{text.split(" ").filter((element)=>{return element.length!==0}).length} words and {text.length} characters</b></p>
                <p><b>{0.008 * text.split(" ").length} Minutes Required For Reading</b></p>
                <h2>Preview</h2>
                <p>{text}</p>
            </div>
        </>
    )
}
